import type { BeatState } from '../types';
import { DEFAULT_BPM } from '../types';

export interface BeatClockOptions {
  bpm: number;
  manualTapTimes?: number[];
  beatOffsetMs?: number;
}

export function estimateBpmFromTap(taps: number[]): number {
  if (taps.length < 2) return DEFAULT_BPM;
  const intervals: number[] = [];
  for (let i = 1; i < taps.length; i++) intervals.push(taps[i] - taps[i - 1]);
  const avg = intervals.reduce((a, b) => a + b, 0) / intervals.length;
  if (avg <= 0) return DEFAULT_BPM;
  return Math.max(60, Math.min(220, Math.round(60_000 / avg)));
}

export function computeBeatState(
  progressMs: number,
  options: BeatClockOptions,
  prevBeatIndex: number
): BeatState {
  const bpm = Math.max(60, Math.min(220, options.bpm || DEFAULT_BPM));
  const beatMs = 60_000 / bpm;
  const beatOffsetMs = Math.max(0, Math.min(8000, options.beatOffsetMs || 0));
  const alignedProgressMs = Math.max(0, progressMs - beatOffsetMs);
  const beatIndex = Math.floor(alignedProgressMs / beatMs);
  const beatPhase = (alignedProgressMs % beatMs) / beatMs;
  const isBeat = beatIndex !== prevBeatIndex;
  const attack = Math.pow(Math.max(0, 1 - beatPhase), 0.55);
  const beatStrength = isBeat ? 1.8 : 0.35 + attack * 0.65;

  return {
    bpm,
    beatIndex,
    beatPhase,
    isBeat,
    beatStrength,
    barIndex: Math.floor(beatIndex / 4),
  };
}

export function syntheticPulse(progressMs: number, bpm: number, band = 0): number {
  const beatMs = 60_000 / Math.max(60, bpm);
  const phase = ((progressMs + band * beatMs * 0.25) % beatMs) / beatMs;
  return Math.pow(Math.max(0, 1 - phase), band === 0 ? 0.45 : 0.8);
}
